<template>
  <evaluate-container
    :list="questions"
    :answers="answers"
    :all="all"
    :tree="tree"
    :is-view="isView"
    :role="role"
    :info="info"
    :find-answer="findAnswer"
    :node-click="handleNodeClick"
  >
    <template
      v-slot:default="{
        forms,
        current,
        currentForm,
        currentIndex,
        indexChange,
        upload,
        down,
      }"
    >
      <el-form ref="form" :model="currentForm" :rules="rules">
        <h2>{{ current.name }}</h2>
        <div
          class="flex flex-col xl:flex-row md:space-x-5"
          v-if="currentForm.quesId && current.question"
        >
          <div
            class="xl:w-1/2 flex flex-col space-y-20 flex-none"
            :class="
              [1, 4, 6, 7, 8, 9, 10, 11, 14, 15].includes(current.question.i)
                ? 'xl:w-3/4'
                : ''
            "
          >
            <div class="flex flex-none space-x-2 justify-between">
              <div>
                <h2>
                  <span v-if="current.question.status === 1">(多选)</span
                  >{{ current.question.name }}
                </h2>
                <p
                  v-if="[2, 3].includes(current.question.i)"
                  class="text-red-600 text-xs"
                >
                  该选项根据公司设备情况自动填报
                </p>
                <p
                  v-else-if="[11, 14, 15].includes(current.question.i)"
                  class="text-red-600 text-xs"
                >
                  该选项根据企业基本信息填报内容自动生成，无需作答！
                </p>
                <p
                  v-else-if="current.question.i === 12"
                  class="text-red-600 text-xs"
                >
                  该选项根据改造前后能源变化情况自动生成，请如实填报右侧表单！
                </p>
                <p
                  v-else-if="current.question.i === 13"
                  class="text-red-600 text-xs"
                >
                  该选项根据改造前后合格率变化情况自动生成，请如实填报右侧表单！
                </p>
                <p
                  v-else-if="current.question.i === 5"
                  class="text-red-600 text-xs"
                >
                  该选项根据业务环节自动计算生成，请如实填报右侧表单！
                </p>
                <el-form-item
                  v-if="current.question.i === 2 && currentForm.ans"
                >
                  <p
                    class="text-blue-400 text-xs"
                    v-html="
                      `设备数: ${currentForm.otherAns.all}, 其中数字化设备数: ${currentForm.otherAns.digit}, 数字化率: <span style='color: red'>${currentForm.otherAns.digitRate}%</span>`
                    "
                  ></p>
                </el-form-item>
                <el-form-item
                  v-if="current.question.i === 3 && currentForm.ans"
                >
                  <p
                    class="text-blue-400 text-xs"
                    v-html="
                      `设备数: ${currentForm.otherAns.all}, 其中联网设备数: ${currentForm.otherAns.online}, 联网率: <span style='color: red'>${currentForm.otherAns.onlineRate}%</span>`
                    "
                  ></p>
                </el-form-item>
                <el-form-item
                  class="text-blue-400 text-xs"
                  v-if="
                    current.question.i === 11 && currentForm.otherAns.digitInput
                  "
                >
                  <template v-if="currentForm.otherAns.version">
                    <p>
                      企业{{
                        currentForm.otherAns.year.join("、")
                      }}年数字化投入分别为{{
                        currentForm.otherAns.digitInput.join("、")
                      }}万元
                    </p>
                    <p>
                      企业{{
                        currentForm.otherAns.year.join("、")
                      }}年营业收入分别为{{
                        currentForm.otherAns.revenue.join("、")
                      }}万元
                    </p>
                    <p>
                      得出企业近三年平均数字化投入总额占营业额的平均比例为<span
                        style="color: red"
                        >{{
                          (currentForm.otherAns.result * 1 || 0).toFixed(3) * 1
                        }}%</span
                      >
                    </p>
                  </template>
                  <template v-else>
                    <p>
                      企业2021、2022、2023年数字化投入分别为{{
                        currentForm.otherAns.digitInput.join("、")
                      }}万元
                    </p>
                    <p>
                      企业2021、2022、2023年营业收入分别为{{
                        currentForm.otherAns.revenue.join("、")
                      }}万元
                    </p>
                    <p>
                      得出企业近三年平均数字化投入总额占营业额的平均比例为<span
                        style="color: red"
                        >{{
                          (currentForm.otherAns.result * 1 || 0).toFixed(3) * 1
                        }}%</span
                      >
                    </p>
                  </template>
                </el-form-item>
                <el-form-item
                  class="text-blue-400 text-xs"
                  v-if="
                    current.question.i === 12 &&
                    currentForm.otherAns.result > -2
                  "
                >
                  <p>
                    企业数字化改造前综合能源消费量为{{
                      currentForm.otherAns.beforeCost.toFixed(3)
                    }}
                  </p>
                  <p>
                    企业数字化改造后综合能源消费量为{{
                      currentForm.otherAns.afterCost.toFixed(3)
                    }}
                  </p>
                  <p>
                    得出企业数字化改造后综合能源消费量相比于改造前<span
                      style="color: red"
                      >{{
                        currentForm.otherAns.result === 1
                          ? "增加"
                          : currentForm.otherAns.result === 0
                          ? "持平"
                          : "降低"
                      }}</span
                    >
                  </p>
                </el-form-item>
                <el-form-item
                  class="text-blue-400 text-xs"
                  label=""
                  v-if="
                    current.question.i === 14 && currentForm.otherAns.thisYear
                  "
                >
                  <template v-if="currentForm.otherAns.version">
                    <p>
                      企业{{ currentForm.otherAns.year[1] }}年度营业收入为{{
                        currentForm.otherAns.thisYear.personRevenue
                      }}万元，从业人员{{
                        currentForm.otherAns.thisYear.personCount
                      }}人，人均营业收入{{
                        currentForm.otherAns.thisYear.average
                      }}万元/人
                    </p>
                    <p>
                      企业{{ currentForm.otherAns.year[0] }}年度营业收入为{{
                        currentForm.otherAns.lastYear.personRevenue
                      }}万元，从业人员{{
                        currentForm.otherAns.lastYear.personCount
                      }}人，人均营业收入{{
                        currentForm.otherAns.lastYear.average
                      }}万元/人
                    </p>
                    <p>
                      得出企业上年度人均营业收入相比于前年为<span
                        style="color: red"
                        >{{
                          currentForm.otherAns.result === 1
                            ? "增加"
                            : currentForm.otherAns.result === 0
                            ? "持平"
                            : "降低"
                        }}</span
                      >情况
                    </p>
                  </template>
                  <template v-else>
                    <p>
                      企业2023年度营业收入为{{
                        currentForm.otherAns.thisYear.personRevenue
                      }}万元，从业人员{{
                        currentForm.otherAns.thisYear.personCount
                      }}人，人均营业收入{{
                        currentForm.otherAns.thisYear.average
                      }}万元/人
                    </p>
                    <p>
                      企业2022年度营业收入为{{
                        currentForm.otherAns.lastYear.personRevenue
                      }}万元，从业人员{{
                        currentForm.otherAns.lastYear.personCount
                      }}人，人均营业收入{{
                        currentForm.otherAns.lastYear.average
                      }}万元/人
                    </p>
                    <p>
                      得出企业上年度人均营业收入相比于前年为<span
                        style="color: red"
                        >{{
                          currentForm.otherAns.result === 1
                            ? "增加"
                            : currentForm.otherAns.result === 0
                            ? "持平"
                            : "降低"
                        }}</span
                      >情况
                    </p>
                  </template>
                </el-form-item>
                <el-form-item
                  class="text-blue-400 text-xs"
                  label=""
                  v-if="
                    current.question.i === 15 && currentForm.otherAns.thisYear
                  "
                >
                  <template v-if="currentForm.otherAns.version">
                    <p>
                      企业{{ currentForm.otherAns.year[1] }}年成本
                      {{
                        (currentForm.otherAns.thisYear.cost * 1 || 0).toFixed(2)
                      }}
                      万元，营业收入
                      {{ currentForm.otherAns.thisYear.personRevenue }}
                      万元，每百元营业收入中的成本为
                      {{ currentForm.otherAns.thisYear.perCost }} 元
                    </p>
                    <p>
                      企业{{ currentForm.otherAns.year[0] }}年成本
                      {{
                        (currentForm.otherAns.lastYear.cost * 1 || 0).toFixed(2)
                      }}
                      万元，营业收入
                      {{ currentForm.otherAns.lastYear.personRevenue }}
                      万元，每百元营业收入中的成本为
                      {{ currentForm.otherAns.lastYear.perCost }} 元
                    </p>
                    <p>
                      得出企业上年度每百元营业收入中的成本相比于前年为<span
                        style="color: red"
                        >{{
                          currentForm.otherAns.result === 1
                            ? "增加"
                            : currentForm.otherAns.result === 0
                            ? "持平"
                            : "降低"
                        }}</span
                      >情况
                    </p>
                  </template>
                  <template v-else>
                    <p>
                      企业2023 年成本
                      {{
                        (currentForm.otherAns.thisYear.cost * 1 || 0).toFixed(2)
                      }}
                      万元，营业收入
                      {{ currentForm.otherAns.thisYear.personRevenue }}
                      万元，每百元营业收入中的成本为
                      {{ currentForm.otherAns.thisYear.perCost }} 元
                    </p>
                    <p>
                      企业2022 年成本
                      {{
                        (currentForm.otherAns.lastYear.cost * 1 || 0).toFixed(2)
                      }}
                      万元，营业收入
                      {{ currentForm.otherAns.lastYear.personRevenue }}
                      万元，每百元营业收入中的成本为
                      {{ currentForm.otherAns.lastYear.perCost }} 元
                    </p>
                    <p>
                      得出企业上年度每百元营业收入中的成本相比于前年为<span
                        style="color: red"
                        >{{
                          currentForm.otherAns.result === 1
                            ? "增加"
                            : currentForm.otherAns.result === 0
                            ? "持平"
                            : "降低"
                        }}</span
                      >情况
                    </p>
                  </template>
                </el-form-item>
                <el-form-item prop="ans">
                  <el-checkbox-group
                    v-if="current.question.status === 1"
                    size="mini"
                    v-model="currentForm.ans"
                    @change="
                      (val) => handleCheckChange(val, currentForm, current)
                    "
                  >
                    <el-col :span="24">
                      <el-checkbox
                        class="answer-item"
                        :label="item.id"
                        v-for="item in current.question.children"
                        :key="item.id"
                        >{{ item.name }}
                      </el-checkbox>
                    </el-col>
                  </el-checkbox-group>
                  <el-radio-group
                    v-else
                    size="mini"
                    v-model="currentForm.ans"
                    @change="
                      (val) => handleRadioChange(val, currentForm, current)
                    "
                    :disabled="
                      [2, 3, 5, 11, 12, 13, 14, 15].includes(current.question.i)
                    "
                  >
                    <el-radio
                      v-show="
                        !(
                          current.question.i === 8 &&
                          i === current.question.children.length
                        )
                      "
                      class="answer-item"
                      v-for="(item, i) in current.question.children"
                      :key="item.id"
                      :label="item.id"
                      >{{ item.name }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <div
                class="flex-none w-48"
                :key="current.question.id"
                v-if="![2, 3].includes(current.question.i)"
              >
                <h2>
                  佐证材料
                  <el-popover
                    v-if="current.userName"
                    placement="right"
                    title="说明"
                    width="250"
                    trigger="click"
                  >
                    <div
                      class="text-red-500 text-xs mb-5"
                      v-html="current.userName"
                    ></div>
                    <a
                      v-if="current.remark"
                      :href="`/buckets/WENJUAN/${current.remark}`"
                      target="_blank"
                      class="text-blue-400 text-xs"
                      >查看示例</a
                    >
                    <i
                      slot="reference"
                      class="el-icon-question cursor-pointer"
                    ></i>
                  </el-popover>
                </h2>
                <div
                  v-for="(file, index) in currentForm.fileIds"
                  :key="index"
                  class="space-x-2"
                >
                  <el-button
                    type="text"
                    plain
                    @click="down(file)"
                    title="点击下载"
                    >{{ `${index + 1}:${file.name}` }}
                  </el-button>
                  <el-button
                    type="text"
                    plain
                    @click="
                      currentForm.fileIds.splice(index, 1) &&
                        (currentForm.saved = false)
                    "
                    >移除
                  </el-button>
                </div>
                <el-form-item
                  v-if="current.question.i !== 5"
                  prop="fileIds"
                  :rules="{
                    validator: (rule, value, cb) => {
                      handleFileValid(rule, value, cb, currentForm);
                    },
                  }"
                >
                  <el-upload
                    :headers="headers"
                    class="uploader"
                    action="/dev/minio"
                    :before-upload="beforeUpload"
                    :on-success="
                      (res, file, fileList) =>
                        handleSuccess(res, file, fileList, currentForm)
                    "
                    :on-error="handleError"
                    :show-file-list="false"
                  >
                    <el-button size="small" type="primary">点击上传</el-button>
                  </el-upload>
                  <p class="text-xs text-red-400">
                    (支持word、excel、ppt、pdf、jpg格式,上传文件最大限制10MB)
                  </p>
                </el-form-item>
              </div>
            </div>
            <div class="justify-self-end">
              <el-button
                :disabled="currentIndex === 0"
                @click="indexChange(currentIndex - 1)"
                >回到上一题</el-button
              >
              <el-button
                v-if="!isView && current.question.i !== 3"
                @click="handleSave(currentForm, current, forms)"
                :disabled="currentForm.saved"
                >保存
              </el-button>
              <el-button
                :disabled="currentIndex + 1 === questions.length"
                @click="indexChange(currentIndex + 1)"
              >
                进入下一题
              </el-button>
              <el-button
                v-if="currentIndex + 1 === questions.length"
                @click="handleChangeType"
                >进入场景环节</el-button
              >
            </div>
          </div>
          <div class="w-full h-full overflow-auto">
            <question2
              ref="other-form"
              v-if="current.question.i === 2"
              v-bind="{
                ans: currentForm.otherAns,
                cb: (data, fileInfo) =>
                  handleEquipmentChange(data, forms, currentForm, fileInfo),
              }"
            />
            <question3
              ref="other-form"
              v-else-if="current.question.i === 3"
              v-bind="{
                ans: currentForm.otherAns,
                cb: (data) => handleEquipmentChange(data, forms, currentForm),
              }"
            />
            <question5
              ref="other-form"
              v-else-if="current.question.i === 5"
              v-bind="{
                ans: currentForm.otherAns,
                isView,
                upload,
                down,
                cb: (data) => handleSceneChange(data, currentForm, current),
              }"
            />
            <question11
              ref="other-form"
              v-else-if="current.question.i === 11"
              v-bind="{
                ans: currentForm.otherAns,
                userId: info.userId,
                cb: (data, year) =>
                  handleRateChange(data, currentForm, current, year),
              }"
            />
            <question12
              ref="other-form"
              v-else-if="current.question.i === 12"
              v-bind="{
                ans: currentForm.otherAns,
                isView,
                userId: info.userId,
                cb: (data, year) =>
                  handleProfitChange(data, currentForm, current, year),
              }"
            />
            <question13
              ref="other-form"
              v-else-if="current.question.i === 13"
              v-bind="{
                ans: currentForm.otherAns,
                isView,
                cb: (data) => handleProfitChange(data, currentForm, current),
              }"
            />
            <question14
              ref="other-form"
              v-else-if="current.question.i === 14"
              v-bind="{
                ans: currentForm.otherAns,
                userId: info.userId,
                cb: (data, year) =>
                  handleProfitChange(data, currentForm, current, year),
              }"
            />
            <question15
              ref="other-form"
              v-else-if="current.question.i === 15"
              v-bind="{
                ans: currentForm.otherAns,
                userId: info.userId,
                cb: (data, year) =>
                  handleProfitChange(data, currentForm, current, year),
              }"
            />
            <empty-form ref="other-form" v-else />
          </div>
        </div>
      </el-form>
    </template>
    <template v-slot:drawer="{ pivots, current, down }">
      <div class="w-full h-full flex flex-col">
        <el-collapse class="flex-1" :value="pivots.length">
          <el-collapse-item
            v-for="(pivot, index) in pivots"
            :key="index"
            :title="`第${index + 1}轮评审`"
            :name="index + 1"
          >
            <el-form label-position="top">
              <el-form-item label="本轮选择">
                <template v-if="current.question.status === 1">
                  <el-checkbox
                    class="answer-item"
                    :label="item.id"
                    v-for="item in current.question.children.filter((v) =>
                      pivot.ans.includes(v.id)
                    )"
                    :key="item.id"
                    :checked="true"
                    :disabled="true"
                    >{{ item.name }}
                  </el-checkbox>
                </template>
                <template v-else>
                  <el-radio
                    class="answer-item"
                    v-for="item in current.question.children.filter(
                      (v) => v.id * 1 === pivot.ans * 1
                    )"
                    :key="item.id"
                    :label="item.id"
                    :value="item.id"
                    :disabled="true"
                    >{{ item.name }}
                  </el-radio>
                </template>
              </el-form-item>
              <el-form-item label="佐证材料">
                <div
                  v-for="(file, index) in current.i === 5
                    ? Object.values(JSON.parse(pivot.otherAns)).reduce(
                        (a, v) => a.concat(v.fileIds),
                        []
                      )
                    : JSON.parse(pivot.fileIds)"
                  :key="index"
                  class="space-x-2"
                >
                  <el-button
                    type="text"
                    plain
                    @click="down(file)"
                    title="点击下载"
                    >{{ `${index + 1}:${file.name}` }}
                  </el-button>
                </div>
              </el-form-item>
            </el-form>
            <el-descriptions v-if="pivot.pivot" title="评审结果">
              <el-descriptions-item label="专家意见">
                <span v-if="pivot.pivot.status === 0">{{
                  pivot.pivot.remark
                }}</span>
                <span v-else class="text-green-400">通过</span>
              </el-descriptions-item>
              <template v-if="role !== 'enterprise'">
                <el-descriptions-item label="备忘录"
                  ><span>{{ pivot.pivot.txt }}</span></el-descriptions-item
                >
                <el-descriptions-item label="交接说明"
                  ><span>{{ pivot.pivot.nextTxt }}</span></el-descriptions-item
                >
              </template>
            </el-descriptions>
          </el-collapse-item>
        </el-collapse>
        <el-form v-if="mode === 'edit'" inline size="mini">
          <el-form-item>
            <el-button type="primary" @click="handlePivotPass(pivots, current)"
              >通过</el-button
            >
            <el-popover
              placement="top"
              width="400"
              trigger="click"
              @show="handlePivotShow(pivots, current)"
            >
              <el-form
                ref="pivot"
                size="mini"
                :model="pivotForm"
                :rules="rules"
              >
                <el-form-item label="意见" prop="remark">
                  <el-input
                    type="textarea"
                    :rows="3"
                    v-model="pivotForm.remark"
                  />
                </el-form-item>
                <el-form-item label="备忘录" prop="txt">
                  <el-input type="textarea" :rows="3" v-model="pivotForm.txt" />
                </el-form-item>
                <el-form-item label="交接说明" prop="nextTxt">
                  <el-input
                    type="textarea"
                    :rows="3"
                    v-model="pivotForm.nextTxt"
                  />
                </el-form-item>
                <el-form-item>
                  <el-button @click="handlePivotDeny">保存</el-button>
                </el-form-item>
              </el-form>
              <el-button type="danger" slot="reference">拒绝</el-button>
            </el-popover>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </evaluate-container>
</template>

<script>
import EvaluateContainer from "@/views/proposal/partials/EvaluateContainer";
import { addAnswer, addPivot } from "@/api/enterprise";
import EmptyForm from "@/views/proposal/partials/empty-form";
import Question2 from "@/views/proposal/partials/question2";
import Question3 from "@/views/proposal/partials/question3";
import Question5 from "@/views/proposal/partials/question5";
import Question11 from "@/views/proposal/partials/question11";
import Question12 from "@/views/proposal/partials/question12";
import Question13 from "@/views/proposal/partials/question13";
import Question14 from "@/views/proposal/partials/question14";
import Question15 from "@/views/proposal/partials/question15";
import store from "../../../store";

export default {
  props: [
    "info",
    "questions",
    "answers",
    "all",
    "tree",
    "isView",
    "role",
    "mode",
  ],
  components: {
    EvaluateContainer,
    EmptyForm,
    Question2,
    Question3,
    Question5,
    Question11,
    Question12,
    Question13,
    Question14,
    Question15,
  },
  data() {
    return {
      rules: {
        ans: { required: true, message: "请选择选项", trigger: "blur" },
        fileIds: {
          required: true,
          message: "佐证材料不能为空",
          trigger: "blur",
        },
        remark: {
          required: true,
          message: "谰审意见不能为空",
          trigger: "blur",
        },
      },
      pivotForm: {},
      headers: { Authorization: "Bearer " + store.getters.token },
    };
  },
  methods: {
    handleFileValid(rule, value, cb, currentForm) {
      currentForm.nonCheck
        ? cb()
        : value.length
        ? cb()
        : cb(new Error("佐证材料不能为空"));
    },
    findAnswer(v) {
      const item = this.answers.find(
        (a) => a.quesId * 1 === v.question.id * 1
      ) || {
        quesId: v.question.id * 1,
        ans: v.question.status * 1 === 0 ? '""' : "[]",
        fileIds: "[]",
        version: 1,
        otherAns: "{}",
      };
      return Object.assign({}, item, {
        ans: JSON.parse(item.ans),
        otherAns: JSON.parse(item.otherAns),
        fileIds: JSON.parse(item.fileIds),
      });
    },
    //上传前校验
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("上传文件大小不能超过 10MB!");
        return false;
      }
      return true;
    },
    handleSuccess(response, file, fileList, currentForm) {
      currentForm.fileIds.push(response.data);
      currentForm.saved = false;
    },
    handleError(err, file) {
      this.$message.error(err);
    },
    handleRadioChange(val, currentForm, current) {
      const nonItem = current.question.children.find(
        (v) => v.name.trim() === "无"
      );
      currentForm.nonCheck = nonItem && val === nonItem.id;
      currentForm.saved = false;
    },
    handleCheckChange(val, currentForm, current) {
      const nonItem = current.question.children.find(
        (v) => v.name.trim() === "无"
      );
      if (nonItem && val.includes(nonItem.id)) {
        currentForm.ans = [nonItem.id];
        currentForm.nonCheck = true;
      } else {
        currentForm.nonCheck = false;
      }
      currentForm.saved = false;
    },
    handleSave(currentForm, current, forms) {
      Promise.all([
        new Promise((resolve, reject) => {
          this.$refs.form.validate((valid) => {
            valid ? resolve() : reject(new Error("valid"));
          });
        }),
        new Promise((resolve, reject) => {
          this.$refs["other-form"].$children[0].validate((valid) => {
            valid ? resolve() : reject(new Error("valid"));
          });
        }),
      ])
        .then(() => {
          if (current.question.i === 2) {
            const form3 = forms[2];
            const data1 = {
              quesId: currentForm.quesId,
              ans: JSON.stringify(currentForm.ans),
              fileIds: JSON.stringify(currentForm.fileIds),
              otherAns: JSON.stringify(currentForm.otherAns),
              userId: this.info.userId,
              version: 1,
            };
            const data2 = {
              quesId: form3.quesId,
              ans: JSON.stringify(form3.ans),
              fileIds: JSON.stringify(currentForm.fileIds),
              otherAns: JSON.stringify(currentForm.otherAns),
              userId: this.info.userId,
              version: 1,
            };
            Promise.all([addAnswer(data1), addAnswer(data2)]).then((res) => {
              this.$set(currentForm, "id", res[0].data.id);
              currentForm.saved = true;
              this.$set(form3, "id", res[1].data.id);
              form3.saved = true;
              this.$message.success("保存成功！");
              this.$emit("save", res[0].data);
            });
            return;
          }
          const data = {
            quesId: currentForm.quesId,
            ans: JSON.stringify(currentForm.ans),
            fileIds: JSON.stringify(currentForm.fileIds),
            otherAns: JSON.stringify(currentForm.otherAns),
            userId: this.info.userId,
            version: 1,
            ...(currentForm.localYear
              ? { localYear: currentForm.localYear }
              : {}),
          };
          addAnswer(data).then((res) => {
            if (res.code !== 200) {
              this.$message.error(res.message || "未知错误，请销后再试！");
              return;
            }
            this.$set(currentForm, "id", res.data.id);
            currentForm.saved = true;
            this.$message.success("保存成功！");
            this.$emit("save", res.data);
          });
        })
        .catch(() => {});
    },
    handleNodeClick(node) {
      if (node.level === 3) {
        return this.questions.findIndex((v) => v.id === node.id);
      } else return -1;
    },
    handleSceneChange(data, currentForm, current) {
      const rate = Object.keys(data).length;
      let ans;
      if (rate >= 14) {
        ans = current.question.children[4]?.id || 0;
      } else if (rate > 11) {
        ans = current.question.children[3]?.id || 0;
      } else if (rate > 1) {
        ans = current.question.children[2]?.id || 0;
      } else if (rate > 0) {
        ans = current.question.children[1]?.id || 0;
      } else {
        ans = current.question.children[0]?.id || 0;
      }
      Object.assign(currentForm, { saved: false, otherAns: data, ans });
    },
    handleRateChange(data, currentForm, current, year) {
      let ans;
      if (data.result > 60) {
        ans = current.question.children[4]?.id || 0;
      } else if (data.result > 40) {
        ans = current.question.children[3]?.id || 0;
      } else if (data.result > 20) {
        ans = current.question.children[2]?.id || 0;
      } else if (data.result > 10) {
        ans = current.question.children[1]?.id || 0;
      } else {
        ans = current.question.children[0]?.id || 0;
      }
      Object.assign(currentForm, {
        saved: false,
        otherAns: data,
        ans,
        localYear: year,
      });
    },
    handleProfitChange(data, currentForm, current, year) {
      const txt = { [-1]: "降低", 0: "持平", 1: "增加" }[data.result];
      const item = current.question.children.find((v) => v.name === txt);
      Object.assign(
        currentForm,
        { saved: false, otherAns: data, ans: item.id },
        year ? { localYear: year } : {}
      );
    },
    handleEquipmentChange(data, forms, currentForm, fileInfo) {
      const question2 = this.questions[1];
      const question3 = this.questions[2];
      const children2 = question2.question.children;
      const children3 = question3.question.children;
      const form2 = forms[1];
      const form3 = forms[2];
      const ans = {
        1: 0,
        2: 0,
      };
      currentForm.saved = false;
      currentForm.otherAns = data;
      if (data.digitRate > 60) {
        ans[1] = children2[4]?.id;
      } else if (data.digitRate > 40) {
        ans[1] = children2[3]?.id;
      } else if (data.digitRate > 20) {
        ans[1] = children2[2]?.id;
      } else if (data.digitRate > 10) {
        ans[1] = children2[1]?.id;
      } else {
        ans[1] = children2[0]?.id;
      }
      if (data.onlineRate > 60) {
        ans[2] = children3[4]?.id;
      } else if (data.onlineRate > 40) {
        ans[2] = children3[3]?.id;
      } else if (data.onlineRate > 20) {
        ans[2] = children3[2]?.id;
      } else if (data.onlineRate > 10) {
        ans[2] = children3[1]?.id;
      } else {
        ans[2] = children3[0]?.id;
      }

      console.log("eq change", fileInfo);
      Object.assign(form2, {
        saved: false,
        otherAns: data,
        ans: ans[1],
        fileIds: [fileInfo],
      });
      Object.assign(form3, {
        saved: false,
        otherAns: data,
        ans: ans[2],
        fileIds: [fileInfo],
      });
    },
    handleChangeType() {
      this.$emit("change-type", "scene");
    },
    handlePivotPass(pivots, current) {
      const item = pivots.find(
        (p) => p.pivot && p.pivot.version === this.info.version
      );
      (item && item.status === 0
        ? this.$confirm(
            "已有专家评审意见，是否丢弃该意见，改为通过评审?",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
        : Promise.resolve()
      ).then(() => {
        addPivot({
          quesId: current.question.id * 1,
          type: 0,
          userId: this.info.userId,
          status: 1,
          remark: "",
          txt: "",
          nextTxt: "",
        }).then(() => {
          this.$message.success("操作成功");
          this.$emit("pivot", { info: this.info });
        });
      });
    },
    handlePivotShow(pivots, current) {
      const item = pivots.find(
        (p) => p.pivot && p.pivot.version === this.info.version
      );
      if (item) {
        this.pivotForm = {
          quesId: item.pivot.quesId,
          type: item.pivot.type,
          userId: item.pivot.userId,
          status: item.pivot.status,
          remark: item.pivot.remark,
          txt: item.pivot.txt,
          nextTxt: item.nextTxt,
        };
      } else {
        this.pivotForm = {
          quesId: current.question.id * 1,
          type: 0,
          userId: this.info.userId,
          status: 0,
          remark: "",
          txt: "",
          nextTxt: "",
        };
      }
    },
    handlePivotDeny() {
      this.$refs.pivot.validate((valid) => {
        if (valid) {
          addPivot(this.pivotForm).then(() => {
            this.$message.success("操作成功");
            this.$emit("pivot", { info: this.info });
          });
        }
      });
    },
  },
};
</script>
